export * from "./insuranceType/actions";
export * from "./plan/actions";
export * from "./insurance/actions";
export * from "./sponsor/actions";
export * from "./campaign/actions";
export * from "./campaignProject/actions";
export * from "./generateQuote/actions";
export * from "./plans/actions";
export * from "./planBenefit/actions";
export * from "./updateQuote/actions";
export * from "./catalog/actions";
export * from "./beneficiary/actions";
export * from "./insurances/actions";
export * from "./pageActionFlags/actions";
export * from "./avatar/actions";
export * from "./delete/actions";
export * from "./auth/actions";
export * from "./cancelQuote/actions";
export * from "./branches/actions";
export * from "./accountType/actions";
export * from "./projectType/actions";
export * from "./generalCatalog/actions";
export * from "./currencies/actions";
export * from "./rol/actions";
export * from "./collections/actions";
export * from "./permissions/actions";
export * from "./vehiclesApap/actions";
export * from "./apapUploadAttachments/actions";
export * from "./certificates/actions";
export * from "./documentStatistics/actions";
export * from "./reports/actions";
export * from "./premiumCalculate/actions";
export * from "./workFlow/actions";
export * from "./reprintCertifacatesQuote/actions";
export * from "./appointment/actions";

// Global reset action
export const RESET_STORE = "RESET_STORE";
export const resetStore = () => ({
  type: RESET_STORE,
});
